import { useTranslation } from 'react-i18next';
import { Badge } from '@parrot-software/design-system';
import { cn } from '@parrot-software/utils';

interface SubscriptionIntervalBadgeProps {
  className?: string;
  isOneOff?: boolean;
  isPromo?: boolean;
}

/**
 * Badge with the billing interval of a subscription, or the wording of a charge that does not
 * recur: a promotion or a reactivation. Annual subscriptions are not in scope yet.
 */
export const SubscriptionIntervalBadge = ({
  className,
  isOneOff = false,
  isPromo = false,
}: SubscriptionIntervalBadgeProps) => {
  const { t } = useTranslation('subscriptions');

  const label = isOneOff ? t('interval.oneOffBadge') : t(isPromo ? 'interval.promoBadge' : 'interval.monthlyBadge');

  return (
    <Badge
      className={cn(
        'w-fit border-transparent font-sans font-semibold',
        {
          'bg-muted text-muted-foreground hover:bg-muted': isOneOff,
          'bg-bg-warning text-warning hover:bg-bg-warning': isPromo && !isOneOff,
          'bg-bg-info text-info hover:bg-bg-info': !isPromo && !isOneOff,
        },
        className,
      )}
      variant="secondary"
    >
      {label}
    </Badge>
  );
};
